import type {GatewayError} from '@yandex-data-ui/gateway';

import {
    CreateFavoriteArgs,
    CreateFavoriteTagsArgs,
    DeleteFavoriteArgs,
    UpdateFavoriteArgs,
} from '~shared/schema/wiki/actions/favorites';

import {i18n} from '~ui/components/AsideNavigation/i18n';
import {PanelError} from '~ui/store/slices/panels/common/types';
import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';

export const deleteFavorite = createThunk(
    'favorites/delete-favorite',
    (data: DeleteFavoriteArgs & {slug: string}, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.deleteFavorite({favoriteId: data.favoriteId}).catch(
            makeThunkErrorHandler({
                name: 'delete-favorite',
                title: i18n('favorites-delete-error'),
            }),
        );
    },
);

export const createFavorite = createThunk(
    'favorites/create-favorite',
    (data: CreateFavoriteArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.createFavorite(data).catch(
            makeThunkErrorHandler({
                name: 'create-favorite',
                title: i18n('favorites-create-error'),
            }),
        );
    },
);

export const updateFavorite = createThunk(
    'favorites/update-favorite',
    (data: UpdateFavoriteArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.updateFavorite(data).catch(
            makeThunkErrorHandler({
                name: 'update-favorite',
                title: i18n('favorites-update-error'),
            }),
        );
    },
);

export const getFavoriteTags = createThunk('favorites/get-tags', (_, thunkAPI) => {
    const {sdk} = thunkAPI.extra;

    return sdk.wiki.getFavoriteTags().catch((error: GatewayError) => {
        if (error.code === PanelError.UserFeatureIsProcessing) {
            throw error;
        }

        return makeThunkErrorHandler({
            name: 'get-favorite-tags',
            title: i18n('favorites-tags-error'),
        })(error);
    });
});

export const createFavoriteTags = createThunk(
    'favorites/create-tag',
    (data: CreateFavoriteTagsArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.createFavoriteTags(data).catch(
            makeThunkErrorHandler({
                name: 'create-favorite-tag',
                title: i18n('favorites-create-tag-error'),
            }),
        );
    },
);
